import type { GalleryData } from 'ricos-schema';
import { Node_Type } from 'ricos-schema';

import type { NodeBuilder } from './types';

export const gallery = (...args: (NodeBuilder | GalleryData)[]): NodeBuilder => {
  const galleryData = args.find((a): a is GalleryData => !('type' in a));
  const nodeBuilders = args.filter((a): a is NodeBuilder => 'type' in a && a.type === 'block_node');

  return {
    type: 'block_node',
    // @ts-expect-error
    node: getId => ({
      id: getId(),
      type: Node_Type.GALLERY,
      ...(nodeBuilders.length && {
        nodes: nodeBuilders.map(nb => nb.node(getId)),
      }),
      galleryData: galleryData ? galleryData : undefined,
    }),
  };
};
